import React from "react";
import './index.css';
import commander from './../assets/crew/image-douglas-hurley.webp';
import specialist from './../assets/crew/image-mark-shuttleworth.webp';
import pilot from './../assets/crew/image-victor-glover.webp';
import engineer from './../assets/crew/image-anousheh-ansari.webp';

const Crew = () => {

    const crewNav = (e) => {
        e.preventDefault();
        const target = e.currentTarget.getAttribute('data-id');
        const bullets = document.querySelectorAll('.crew-members-nav li');
        const members = document.querySelectorAll('.crew-member');

        bullets.forEach((el) => {
            el.classList.remove('active');
            if(el.getAttribute('data-id').toString() === target.toString()) {
                el.classList.add('active');
            }
        });

        members.forEach((el, idx) => {
            el.classList.remove('show');
            if(idx.toString() === target.toString()) {
                el.classList.add('show');
            }
        });
    };

    return(
        <main className="page crew">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="page-title mb-0">
                            <strong className="page-number">02</strong>
                            Meet your crew
                        </h1>
                        <div className="crew-members">
                            <div className="crew-member show">
                                <figure className="crew-member-figure">
                                    <img className="crew-member-image" src={commander} alt="Douglas Hurley" />
                                </figure>
                                <div className="crew-member-info">
                                    <h2 className="crew-member-job">Commander</h2>
                                    <h3 className="crew-member-name">Douglas Hurley</h3>
                                    <p className="crew-member-desc">Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA astronaut. He launched into space for the third time as commander of Crew Dragon Demo-2.</p>
                                </div>
                            </div>
                            <div className="crew-member">
                                <figure className="crew-member-figure">
                                    <img className="crew-member-image" src={specialist} alt="Mark Shuttleworth" />
                                </figure>
                                <div className="crew-member-info">
                                    <h2 className="crew-member-job">Mission Specialist</h2>
                                    <h3 className="crew-member-name">Mark Shuttleworth</h3>
                                    <p className="crew-member-desc">Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space tourist.</p>
                                </div>
                            </div>
                            <div className="crew-member">
                                <figure className="crew-member-figure">
                                    <img className="crew-member-image" src={pilot} alt="Victor Glover" />
                                </figure>
                                <div className="crew-member-info">
                                    <h2 className="crew-member-job">Pilot</h2>
                                    <h3 className="crew-member-name">Victor Glover</h3>
                                    <p className="crew-member-desc">Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. Glover is a commander in the U.S. Navy where he pilots an F/A-18.He was a crew member of Expedition 64, and served as a station systems flight engineer.</p>
                                </div>
                            </div>
                            <div className="crew-member">
                                <figure className="crew-member-figure">
                                    <img className="crew-member-image" src={engineer} alt="Anousheh Ansari" />
                                </figure>
                                <div className="crew-member-info">
                                    <h2 className="crew-member-job">Flight Engineer</h2>
                                    <h3 className="crew-member-name">Anousheh Ansari</h3>
                                    <p className="crew-member-desc">Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first Iranian in space.</p>
                                </div>
                            </div>
                            <ul className="crew-members-nav">
                                <li className="active" onClick={crewNav} data-id="0"></li>
                                <li onClick={crewNav} data-id="1"></li>
                                <li onClick={crewNav} data-id="2"></li>
                                <li onClick={crewNav} data-id="3"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Crew;